<template>
	<div>
		<div class="f-bold f-16 f-c-black m-d-16" v-if="!tagihanTambahan">
			<img src="../../../../assets/icons/tagihan.svg" alt="" class="m-r-8" style="margin-top: -2px">
			Tagihan
			<span v-if="snapcleanSelfService"> — Self Service</span>
			<span v-if="snapcleanDropOff"> — Drop Off</span>
		</div>
		<div class="m-d-16" v-else>
			<div class="f-regular f-12 f-c-yellow konfirmasi-penghapusan" v-if="false">
				Menunggu konfirmasi penghapusan
			</div>
			<div class="d-flex-between-center m-d-16">
				<div class="f-bold f-16 f-c-black">
					<img src="../../../../assets/icons/tambah-tagihan.svg" alt="" class="m-r-8"
					     style="margin-top: -2px">
					Tagihan Tambahan
				</div>
				<div class="f-semi f-14 f-c-blue" v-if="showDetailTagihanTambahan" @click="detail">
					Detail <img src="@/assets/icons/arrow-right.svg" alt="">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOTagihanHeader",
	props: {
		transaksi: Object,

		tagihanTambahan: Boolean,
		showDetailTagihanTambahan: Boolean,
		isHapusTagihanTambahan: {
			type: Boolean,
			default: false,
		},

		snapcleanSelfService: Boolean,
		snapcleanDropOff: Boolean,
	},
	methods: {
		detail() {
			this.$emit("detail")
		}
	}
}
</script>

<style scoped>
.konfirmasi-penghapusan {
	background: linear-gradient(90deg, #FFF8E1 0%, #FFFFFF 100%);
	padding: 4px 18px;
	margin: -20px -16px 10px;
	border-top-right-radius: 10px;
	border-top-left-radius: 10px;
	/*border-top: 1px solid #C8D0DD;*/
	/*border-left: 1px solid #C8D0DD;*/
	/*border-right: 1px solid #C8D0DD;*/
}
</style>